import { ensureScriptLoaded } from "../utils";

const StorylaneHook = {
  mounted() {
    ensureScriptLoaded({
      src: "https://js.storylane.io/js/v2/storylane.js",
      id: "storylane-script",
    });
  },
};

export default StorylaneHook;
